module.exports = __webpack_public_path__ + "static/media/comingSoonImg.424f5a3b.svg";